import React from "react";
import { useNavigate } from "react-router-dom";
const { useState, useEffect } = React;
const { ArrowRight } = {
  ArrowRight: () => <div>→</div>,
};

export const HeroSection = () => {
  const navigate = useNavigate();
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [isHovered, setIsHovered] = useState(false);
  const [activeService, setActiveService] = useState(null);
  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePosition({
        x: (e.clientX / window.innerWidth) * 100,
        y: (e.clientY / window.innerHeight) * 100,
      });
    };

    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);

  const services = [
    {
      id: "weddings",
      title: "Weddings",
      subtitle: "Timeless love stories",
      icon: "rounded-sm",
      color: "#2dd4bf",
    },
    {
      id: "lifestyle",
      title: "Lifestyle Portraits",
      subtitle: "Natural moments",
      icon: "rounded-none",
      color: "#0f766e",
    },
    {
      id: "maternity",
      title: "Maternity & Newborn",
      subtitle: "Authentic expressions",
      icon: "rounded-full",
      color: "#14b8a6",
    },
  ];

  return (
    <section
      id="home"
      className="relative min-h-screen bg-gradient-to-br from-slate-50 via-white to-teal-50/30 flex items-center justify-center overflow-hidden"
    >
      {/* Interactive Background Elements */}
      <div className="absolute inset-0 z-0">
        {/* Main gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-tr from-teal-500/5 via-transparent to-cyan-400/8"></div>
        <div className="absolute inset-0 bg-gradient-to-bl from-emerald-400/3 via-transparent to-teal-600/6"></div>

        {/* Freely floating images with CSS animations - positioned around content */}
        <div
          className="absolute w-20 h-20 md:w-24 md:h-24 lg:w-32 lg:h-32 rounded-full overflow-hidden shadow-lg opacity-60 md:opacity-70 lg:opacity-80 hover:opacity-100 block"
          style={{
            left: "5%",
            top: "10%",
            animation: "float1 20s ease-in-out infinite",
          }}
        >
          <img
            src="https://res.cloudinary.com/shaszstudios-photography/image/upload/v1763246055/weding_couple_ryru7k.jpg"
            alt="Wedding photography"
            className="w-full h-full object-cover"
          />
        </div>

        <div
          className="absolute w-48 h-48 rounded-full overflow-hidden shadow-xl opacity-70 hover:opacity-95 hidden lg:block"
          style={{
            right: "5%",
            bottom: "10%",
            animation: "float2 25s ease-in-out infinite",
          }}
        >
          <img
            src="https://res.cloudinary.com/shaszstudios-photography/image/upload/v1762207667/maternity_2_edit_3_q4saiy.jpg"
            alt="Maternity photography"
            className="w-full h-full object-cover"
          />
        </div>

        <div
          className="absolute w-20 h-20 md:w-28 md:h-28 lg:w-40 lg:h-40 rounded-full overflow-hidden shadow-lg opacity-60 md:opacity-70 lg:opacity-75 hover:opacity-90 block"
          style={{
            right: "8%",
            top: "12%",
            animation: "float4 22s ease-in-out infinite",
          }}
        >
          <img
            src="https://res.cloudinary.com/shaszstudios-photography/image/upload/v1763243643/family_moments_spring_s2wavv.jpg"
            alt="Family photography"
            className="w-full h-full object-cover"
          />
        </div>

        <div
          className="absolute w-36 h-36 rounded-full overflow-hidden shadow-lg opacity-80 hover:opacity-100 hidden lg:block"
          style={{
            left: "3%",
            top: "60%",
            animation: "float5 24s ease-in-out infinite",
          }}
        >
          <img
            src="https://res.cloudinary.com/shaszstudios-photography/image/upload/v1763243647/couple_in_ams_2_lgfmir.jpg"
            alt="Couple photography"
            className="w-full h-full object-cover"
          />
        </div>

        {/* Animated gradient mesh */}
        <div
          className="absolute inset-0 opacity-40 transition-opacity duration-500"
          style={{
            backgroundImage: `
              radial-gradient(circle at 20% 80%, rgba(20, 184, 166, 0.8) 0%, transparent 60%),
              radial-gradient(circle at 80% 20%, rgba(6, 182, 212, 0.7) 0%, transparent 60%),
              radial-gradient(circle at 40% 40%, rgba(16, 185, 129, 0.6) 0%, transparent 60%)
            `,
            transform: `translate(${mousePosition.x * 0.02}px, ${
              mousePosition.y * 0.02
            }px)`,
          }}
        ></div>

        <style>{`
          @keyframes float1 {
            0%, 100% { transform: translate(0, 0) rotate(0deg); }
            25% { transform: translate(10px, -15px) rotate(1deg); }
            50% { transform: translate(-8px, 12px) rotate(-1deg); }
            75% { transform: translate(5px, -8px) rotate(0.5deg); }
          }
          
          @keyframes float2 {
            0%, 100% { transform: translate(0, 0) rotate(0deg); }
            25% { transform: translate(-12px, 8px) rotate(-1deg); }
            50% { transform: translate(15px, -10px) rotate(1deg); }
            75% { transform: translate(-8px, 6px) rotate(-0.5deg); }
          }
          
          @keyframes float3 {
            0%, 100% { transform: translate(0, 0) rotate(0deg); }
            25% { transform: translate(8px, 12px) rotate(1deg); }
            50% { transform: translate(-10px, -8px) rotate(-1deg); }
            75% { transform: translate(6px, 10px) rotate(0.5deg); }
          }
          
          @keyframes float4 {
            0%, 100% { transform: translate(0, 0) rotate(0deg); }
            25% { transform: translate(-15px, 10px) rotate(-1deg); }
            50% { transform: translate(12px, -12px) rotate(1deg); }
            75% { transform: translate(-8px, 8px) rotate(-0.5deg); }
          }
          
          @keyframes float5 {
            0%, 100% { transform: translate(0, 0) rotate(0deg); }
            25% { transform: translate(-10px, -12px) rotate(1deg); }
            50% { transform: translate(8px, 15px) rotate(-1deg); }
            75% { transform: translate(-6px, -10px) rotate(0.5deg); }
          }
        `}</style>
      </div>

      {/* Main Content */}
      <div className="relative z-10 text-center px-6 max-w-6xl mx-auto pt-20 pb-20 md:py-0">
        {/* Primary Heading with hover effect */}
        <div className="mb-16">
          <h1
            className="text-4xl md:text-6xl lg:text-8xl font-extralight text-gray-900 mb-8 leading-[0.9] tracking-tight transition-all duration-500 cursor-default"
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            SHASZ
            <span
              className={`block font-light italic mt-2 transition-all duration-500 ${
                isHovered ? "text-teal-500 scale-105" : "text-teal-600"
              }`}
            >
              Studios
            </span>
          </h1>

          {/* Animated divider */}
          <div className="flex items-center justify-center mb-8">
            <div
              className={`h-px bg-teal-500 transition-all duration-700 ${
                isHovered ? "w-24" : "w-16"
              }`}
            ></div>
            <div
              className={`w-2 h-2 bg-teal-500 rounded-full mx-4 transition-all duration-500 ${
                isHovered ? "scale-150 bg-teal-400" : ""
              }`}
            ></div>
            <div
              className={`h-px bg-teal-500 transition-all duration-700 ${
                isHovered ? "w-24" : "w-16"
              }`}
            ></div>
          </div>

          <p className="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto leading-relaxed font-light tracking-wide">
            Capturing life's most precious moments through the lens of artistry,
            emotion, and timeless elegance
          </p>
        </div>

        {/* Interactive Services Preview */}
        <div className="grid md:grid-cols-3 gap-12 mb-16 text-center">
          {services.map((service, index) => (
            <div
              key={service.id}
              className="group cursor-pointer"
              onMouseEnter={() => setActiveService(service.id)}
              onMouseLeave={() => setActiveService(null)}
              onClick={() => {
                const routes = {
                  weddings: '/wedding-portfolio',
                  lifestyle: '/lifestyle-portfolio',
                  maternity: '/maternity-portfolio'
                };
                navigate(routes[service.id]);
              }}
            >
              <div
                className={`w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4 transition-all duration-500 transform ${
                  activeService === service.id
                    ? "scale-110 shadow-lg"
                    : "group-hover:scale-105"
                }`}
                style={{
                  backgroundColor:
                    activeService === service.id
                      ? `${service.color}20`
                      : "#14b8a615",
                }}
              >
                <div
                  className={`w-6 h-6 border-2 transition-all duration-300 ${service.icon}`}
                  style={{
                    borderColor:
                      activeService === service.id ? service.color : "#14b8a6",
                    transform:
                      activeService === service.id
                        ? "rotate(360deg)"
                        : "rotate(0deg)",
                  }}
                ></div>
              </div>
              <h3
                className={`text-sm font-light tracking-widest uppercase mb-2 transition-colors duration-300 ${
                  activeService === service.id
                    ? "text-teal-600"
                    : "text-gray-800"
                }`}
              >
                {service.title}
              </h3>
              <p
                className={`text-xs font-light transition-all duration-300 ${
                  activeService === service.id
                    ? "text-teal-500 transform translate-y-1"
                    : "text-gray-500"
                }`}
              >
                {service.subtitle}
              </p>
            </div>
          ))}
        </div>

        {/* Enhanced Call to Action */}
        <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
          <button
            onClick={() => navigate("/portfolio")}
            className="group relative overflow-hidden flex items-center gap-3 bg-gradient-to-r from-teal-500 to-teal-600 text-white hover:from-teal-600 hover:to-teal-700 px-10 py-4 font-light tracking-widest text-xs uppercase transition-all duration-500 transform hover:scale-105 hover:shadow-xl"
          >
            <span className="relative z-10">VIEW PORTFOLIO</span>
            <ArrowRight className="group-hover:translate-x-1 transition-transform w-4 h-4 relative z-10" />
            <div className="absolute inset-0 bg-gradient-to-r from-teal-400 to-teal-500 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
          </button>

          <button onClick={() => navigate("/book-now")} className="group relative flex items-center gap-3 bg-transparent border-2 border-gray-300 text-gray-700 hover:border-teal-500 hover:text-teal-600 px-10 py-4 font-light tracking-widest text-xs uppercase transition-all duration-500 hover:shadow-lg">
            <span>GET IN TOUCH</span>
            <div className="w-4 h-4 border-r-2 border-t-2 border-current transform rotate-45 group-hover:translate-x-1 group-hover:scale-110 transition-all duration-300"></div>
          </button>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
